import React, { useCallback } from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { CurrencyInput } from 'ui-components/components/currency-input';

import style from './style.module.less';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';

const defaultAmount = { value: 0, code: 'USD' };

const OrderSummaryCurrencyInput = ({ labelTranslation, currencyAmount = defaultAmount, onChange, name }) => {
  const nonNullCurrencyAmount = currencyAmount === null ? defaultAmount : currencyAmount;
  const intl = useIntl();
  const hasAmount = get(nonNullCurrencyAmount, 'value', 0) > 0;
  const change = useCallback(
    (value) => {
      onChange(name, { ...nonNullCurrencyAmount, value });
    },
    [nonNullCurrencyAmount, name, onChange],
  );
  return (
    <div className={style['input-wrapper']}>
      <label className={style['input-label']}>{intl.formatMessage(labelTranslation)}</label>
      <CurrencyInput
        className={style['currency-input']}
        currencyCode={nonNullCurrencyAmount.code}
        onChange={change}
        value={hasAmount ? nonNullCurrencyAmount.value : ''}
      />
    </div>
  );
};

OrderSummaryCurrencyInput.propTypes = {
  labelTranslation: MessageDescriptorPropType.isRequired,
  currencyAmount: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export default OrderSummaryCurrencyInput;
